import { render, staticRenderFns } from "./DataPointEditor.vue?vue&type=template&id=2784abf6"
import script from "./DataPointEditor.vue?vue&type=script&lang=js"
export * from "./DataPointEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports